import { useRef } from 'react';
import Konva from 'konva';

import { clampZoom } from '../core/viewport';

Konva.hitOnDragEnabled = true;

const getTouchPoint = (stage, touch) => {
  const rect = stage.container().getBoundingClientRect();
  return { x: touch.clientX - rect.left, y: touch.clientY - rect.top };
};

const getDistance = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);

const getCenter = (a, b) => ({ x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 });

const stopActiveGestures = (stage) => {
  stage.find((node) => node.isDragging?.()).forEach((node) => node.stopDrag());
  stage.find('Transformer').forEach((transformer) => {
    if (transformer.isTransforming()) {
      transformer.stopTransform();
    }
  });
};

const useCanvasPinch = ({ stageRef, viewport, onViewportChange }) => {
  const pinchRef = useRef(null);

  const handlePinchMove = (event) => {
    const stage = stageRef.current;
    const touches = event.evt.touches;
    if (!stage || touches?.length !== 2) {
      return false;
    }

    event.evt.preventDefault();
    const first = getTouchPoint(stage, touches[0]);
    const second = getTouchPoint(stage, touches[1]);
    const center = getCenter(first, second);
    const distance = getDistance(first, second);
    const previous = pinchRef.current;

    if (!previous) {
      stopActiveGestures(stage);
      pinchRef.current = { center, distance, viewport: { zoom: viewport.zoom, x: viewport.x, y: viewport.y } };
      return true;
    }

    const current = previous.viewport;
    const zoom = clampZoom(current.zoom * (distance / (previous.distance || distance)));
    const pointTo = {
      x: (previous.center.x - current.x) / current.zoom,
      y: (previous.center.y - current.y) / current.zoom,
    };
    const next = { zoom, x: center.x - pointTo.x * zoom, y: center.y - pointTo.y * zoom };

    pinchRef.current = { center, distance, viewport: next };
    onViewportChange(next);
    return true;
  };

  const handlePinchEnd = (event) => {
    if ((event.evt.touches?.length || 0) < 2) {
      pinchRef.current = null;
    }
  };

  return { handlePinchMove, handlePinchEnd };
};

export default useCanvasPinch;
